// extracted by mini-css-extract-plugin
export default {"talkUploadPreviewContainer":"VideoTextTalkUploadPreview_talkUploadPreviewContainer__MoyqT","talkUploadPreview":"VideoTextTalkUploadPreview_talkUploadPreview__VW-gj"};